import { useSiteMetadata } from './site-metadata-hook';

export const useBaseUrl = (): string => {
  return useSiteMetadata().baseUrl;
};

export const useApiBaseUrl = (): string => {
  return useSiteMetadata().apiBaseUrl;
};
